import api from "@/services/api";
import { BulkCustomerInput } from "./PreviewBulkClients";

export type BulkCustomerResultItem = {
  row: number;
  document: string;
  name?: string;
  phone?: string;
  email?: string;
  id?: string;
  reason?: string;
};

export type BulkCustomersCreateResponse = {
  created: BulkCustomerResultItem[];
  skipped: BulkCustomerResultItem[];
  failed: BulkCustomerResultItem[];
};

class ConfirmBulkClients {
  execute = async (customers: BulkCustomerInput[]) => {
    const response = await api().post(`/customers/bulk`, {
      customers,
    });
    return response.data as BulkCustomersCreateResponse;
  };
}

export { ConfirmBulkClients };
